import MyOrderCard from './my-order-card';

export default function MyOrders({ productSummary, setOrder }: any) {

  return (
    <>
      <div className="bg-white p-4">

        <div className='flex justify-between mb-4 items-center whitespace-nowrap'>
          <h2 className='text-lg sm:text-xl font-semibold'>My Orders</h2>
        </div>

        <MyOrderCard productSummary={productSummary} setOrder={setOrder} />
      </div>
    </>
  );
}
